export const landFilterDefaults = {
  tax_number: '',
  id_number: '',
  farmer_name: '',
  date: '',
};

export const landFilterFields = [
  'tax_number',
  'id_number',
  'page',
  'date',
  'farmer_name',
] as const;
